import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const editChallengeAssessorsRequest = createAction('editChallengeAssessorsRequest');
export const editChallengeAssessorsSuccess = createAction('editChallengeAssessorsSuccess');
export const editChallengeAssessorsFailure = createAction('editChallengeAssessorsFailure');

export const editChallengeAssessors = (postbody: EditChallengeAssessorsRequest) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(editChallengeAssessorsRequest());
    try {
        await api.post('admin/challenges/attach-assessors', postbody);

        dispatch(editChallengeAssessorsSuccess());
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeAssessorsFailure, e);
    }
};

export interface EditChallengeAssessorsRequest {
    assessorIDs: number[];
    challengeID: number;
}
